import { motion } from "framer-motion";
import { Heart, Palette, Sparkles, BookOpen, Award, Smile, Check } from "lucide-react";

const ICONS = {
  heart: Heart,
  palette: Palette,
  sparkles: Sparkles,
  "book-open": BookOpen,
  award: Award,
  smile: Smile,
};

const EASE = [0.22, 1, 0.36, 1];

export const Benefits = ({ content }) => {
  const benefits = content.benefits || [];
  const includes = content.includes || [];

  return (
    <section id="benefici" className="paper-texture py-16 sm:py-24" data-testid="benefits-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-6 max-w-2xl"
        >
          <span className="font-editorial text-sm italic tracking-wide text-terracotta">Il manifesto del quaderno</span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-olive sm:text-3xl lg:text-4xl" data-testid="benefits-title">
            Crescere sereni, un'emozione alla volta
          </h2>
        </motion.div>

        <div>
          {benefits.map((b, i) => {
            const Icon = ICONS[b.icon] || Heart;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: EASE }}
                data-testid={`benefit-card-${i}`}
                className={`group flex flex-col gap-5 border-t border-sand py-10 sm:py-12 md:flex-row md:items-center md:gap-10 ${i % 2 ? "md:flex-row-reverse" : ""}`}
              >
                <span className="text-outline font-display text-7xl font-extrabold leading-none transition-colors duration-500 group-hover:text-terracotta group-hover:[-webkit-text-stroke:0px] sm:text-8xl md:w-40 md:shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="md:w-72 md:shrink-0">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-terracotta-light text-terracotta transition-colors duration-300 group-hover:bg-terracotta group-hover:text-white">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-4 font-display text-lg font-semibold text-olive sm:text-xl">{b.title}</h3>
                </div>
                <p className="text-base leading-relaxed text-stone-600 sm:text-lg md:flex-1">{b.text}</p>
              </motion.div>
            );
          })}
        </div>

        {includes.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="mt-12 rounded-3xl bg-olive p-8 text-white sm:p-10"
            data-testid="includes-box"
          >
            <div className="grid items-center gap-8 lg:grid-cols-[1fr_1.2fr]">
              <div>
                <h3 className="font-display text-xl font-bold sm:text-2xl">Dentro il quaderno trovi</h3>
                <p className="mt-3 text-sm text-white/80 sm:text-base">
                  {content.pages_count} pagine in formato grande, pensate per essere colorate, disegnate e vissute ogni giorno.
                </p>
              </div>
              <ul className="space-y-3">
                {includes.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 rounded-xl bg-white/10 px-4 py-3" data-testid={`include-item-${i}`}>
                    <Check className="mt-0.5 h-5 w-5 shrink-0 text-amazon-orange" />
                    <span className="text-sm font-medium sm:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
};
